import Immutable from "seamless-immutable";

const initialState = Immutable({});

const WilRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default WilRegisterReducer;
